<div class="everything">
    <app-navbar></app-navbar>
  <main>
    <div>
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>
</div>
<app-toast />
